import React, { useState, useEffect } from "react";

const PopUp = ({ handleFilterApply, popupStyle, columns, displayedColumns, onClose }) => {
  // Initialize filters - default all to true if displayedColumns is empty
  const getInitialFilters = React.useCallback(() => {
    if (displayedColumns && Object.keys(displayedColumns).length > 0) {
      return { ...displayedColumns };
    }
    // Default all columns to true
    const defaults = {};
    if (columns && columns.length > 0) {
      columns.forEach((col) => {
        const lowerKey = col.key.toLowerCase();
        if (lowerKey !== 'day' && lowerKey !== 'collected' && lowerKey !== 'collectedvol') {
          defaults[lowerKey] = true;
        }
      });
    }
    return defaults;
  }, [displayedColumns, columns]);

  const [filters, setFilters] = useState(() => getInitialFilters());

  // Sync when displayedColumns or columns change (e.g., first load)
  useEffect(() => {
    const newFilters = getInitialFilters();
    setFilters(newFilters);
  }, [getInitialFilters]);

  const handleApplyFilter = (event) => {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    handleFilterApply(filters);
  };

  const handleCheckboxChange = (filterKey) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey]: !prevFilters[filterKey],
    }));
  };

  return (
    <div
      className="overlay parent_popup"
      style={popupStyle}
      role="dialog"
      aria-modal="true"
      aria-labelledby="display-options-heading"
    >
      <div className="popup" style={{ display: "block" }}>
        <header
          className="popup__header"
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}
        >
          <h3 id="display-options-heading" style={{ margin: 0, fontSize: "22px" }}>
            Select which options to display
          </h3>
          {onClose && (
            <button
              type="button"
              className="icon-button icon-button--circle"
              onClick={onClose}
              aria-label="Close display options"
            >
              <span aria-hidden="true" style={{ fontSize: "20px", lineHeight: 1 }}>
                &times;
              </span>
            </button>
          )}
        </header>

        <div className="popupcontent custom_popupcontent">
          <ul>
            {columns.map((col) => (
              <li key={col.key}>
                <div className="checkbox">
                  <label className="checkcontainer">
                    <input
                      type="checkbox"
                      checked={filters[col.key.toLowerCase()] || false}
                      onChange={() => handleCheckboxChange(col.key.toLowerCase())}
                      id={`chk-${col.key.toLowerCase()}`}
                    />
                    <span className="cr">
                      <i className="cr-icon uicon-check" />
                    </span>
                    {col.label}
                  </label>
                </div>
              </li>
            ))}
          </ul>

          <div className="apply-filter_ct" id="apply-filter">
            <a href="#apply-filter" onClick={handleApplyFilter}>
              <span>Apply Filter</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
